import SideBar from "../../Components/Utilities/SideBar";
import { Navigate } from "react-router-dom";
import AllBackupsComponent from "../../Components/Backups/AllBackupsComponent";

export default function BackupsPage() {

    const loggedUser = JSON.parse(localStorage.getItem("user"));
    if (!loggedUser) {
        return <Navigate to='/' />
    }


    if (!loggedUser?.isAdmin) return <Navigate to='/' />;


    return (
        <div className="d-flex justify-content-start">
            <div>
                <SideBar />
            </div>
            <div className={`p-3 w-100 dashboard`} style={{ overflow: "hidden" }}>
                <AllBackupsComponent />
            </div>
        </div>
    )
}
